import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Dashboard from './Dashboard';
import Bateaux from './Bateaux';
import Checklist from './Checklist';
import Navigation from './Navigation';
import Profil from './Profil';
import Meteo from './Meteo';

function App() {
  const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
  };

  const PrivateRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/login" />;
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* Routes publiques */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        
        {/* Routes privées */}
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/bateaux" element={<PrivateRoute><Bateaux /></PrivateRoute>} />
        <Route path="/profil" element={<PrivateRoute><Profil /></PrivateRoute>} />
        <Route path="/bateau/:bateauId" element={<PrivateRoute><Checklist /></PrivateRoute>} />
        <Route path="/bateau/:bateauId/navigation" element={<PrivateRoute><Navigation /></PrivateRoute>} />
        <Route path="/checklist/:bateauId" element={<PrivateRoute><Checklist /></PrivateRoute>} />
        <Route path="/navigation/:bateauId" element={<PrivateRoute><Navigation /></PrivateRoute>} />
        <Route path="/meteo" element={<PrivateRoute><Meteo /></PrivateRoute>} />
        
        {/* Redirection par défaut */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;